/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import _ from 'lodash';
import { Box, Grid, Typography } from '@mui/material';
import DepartmentBox from '../../common/components/DepartmentBox';
import EmpDirectoryBox from '../../common/components/EmpDirectoryBox/EmpDirectoryBox';
import SearchComponent from '../../common/components/SearchComponent';
import emptyIcon from '../../assets/images/empty_icon.svg';
import './EmpDirectory.css';
import { fonts, themes } from '../../common/themes/themes';
import Loader from '../../common/Lottifiers/Loader/Loader';
import { useAppSelector } from '../../infra/hooks';
import Pagination from '../../common/components/Pagination/Pagination';

interface propsType {
  EmpDirectory: any;
  allDepartment: any;
  isLoading?: boolean;
  setPageChange?: any;
  totalEmpDirectory: any;
  trans?: any;
  i18n?: any;
  getPageValue?: any;
  getRowPerPageValue?: any;
  page?:any;
  rowPerPage?:any ;
  count?:any ;
  handlegetEmpdocDept?: (event:any) => void;
  setSearch: ((event: any) => void | undefined)
}
const EmpDirectoryPresenter: React.FC<propsType> = ({
  EmpDirectory,
  allDepartment,
  isLoading,
  trans,
  i18n,
  getPageValue,
  getRowPerPageValue,
  page,
  rowPerPage,
  count,
  handlegetEmpdocDept,
  setSearch,
}) => {

  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);

  const setTextFilterSearch = (e:any)=>{
    setSearch(e)
  }

  const filterEmpdocs = () => {
    return EmpDirectory;
  };
  return (
    <Grid
      container
      style={{
        height: '100%',
        marginTop: '4em',
        width:"90vw"
      }}
    >
      <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: isHRView ? '-3em' : '',
          }}
        >
        <Grid
              container
              spacing={2}
              sx={{
                backgroundColor: '#F5F5FA',
                width: '100%',
                height: 'auto',
                paddingLeft: '1.75em',
                marginRight: i18n.language == 'ar' ? '6em' : '',
              }}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                sx={{
                  display: 'flex',
                  padding: '20px',
                  flexWrap: 'wrap',
                }}
              >
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    sx={{
                      width: '100%',
                      marginTop: '1.75em',
                    }}
                  >
                    <Box
                      style={{
                        width: 'auto',
                        height: 'auto',
                        background: '#FFFFFF 0% 0% no-repeat padding-box',
                        borderRadius: '10px',
                        opacity: '1',
                      }}
                    >
                      <Grid
                        item
                        xs={12}
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          padding:"1em"
                        }}
                      >
                        <Grid item xs={9}>
                          <Typography
                            style={{
                              fontFamily: fonts.fontFamily,
                              fontSize: fonts.header,
                              color: themes.blackDefault,
                              fontWeight: 'bold',
                            }}
                          >
                            {trans('Employee Directory')}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>

                <Grid container spacing={1} >
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Box className="empCard" >
                      <Grid container spacing={1} direction="row">
                        <Grid item>
                          <SearchComponent
                            onChange={(e: any) => setTextFilterSearch(e)}
                            padding="5px"
                          />
                        </Grid>
                        <Grid item style={{ marginRight: '1.2em' }}>
                          <DepartmentBox
                            allDepartments={allDepartment}
                            selectedDepartments={handlegetEmpdocDept}
                          />
                        </Grid>
                      </Grid>
                      <Box style={{ marginBottom: '24px' }} />
                      {!isLoading ? (
                        <div className=''>
                        {filterEmpdocs()?.length > 0 ? (
                        <>
                          <Grid
                            container
                            spacing={2}
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                            }}
                          >
                            {_.map(filterEmpdocs(), function (Dir: any) {
                              let activeStatus;
                              if(!Dir?.employee_a_d_status){
                                  activeStatus = true
                              }else{
                                  activeStatus = false
                              }
                              let profile_pic =
                                '/public/images/default_avatar.png';
                              if (Dir?.user?.profile_pic){
                                profile_pic = Dir?.user?.profile_pic;
                              }
                              return (
                                <Grid item>
                                  <EmpDirectoryBox
                                    data={Dir}
                                    active={activeStatus}
                                    profile={profile_pic}
                                    title={`${Dir?.first_name} ${Dir?.last_name}`}
                                    designation={
                                      Dir
                                        ? Dir?.emp_job_detail?.designation?.name
                                        : ''
                                    }
                                    department={
                                      Dir
                                        ? Dir?.emp_job_detail?.department?.name
                                        : ''
                                    }
                                    email={Dir ? Dir?.email : ''}
                                    mobile={Dir ? Dir?.phone : ''}
                                    landline={
                                      Dir?.ext_number ? Dir?.ext_number : '-- --'
                                    }
                                  />
                                </Grid>
                              );
                            })}
                          </Grid>
                        </>
                        ) : (
                          <Grid
                            container
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <Grid
                              item
                              xs={12}
                              style={{
                                textAlign: 'center',
                              }}
                            >
                              <img src={emptyIcon} />
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              style={{
                                textAlign: 'center',
                              }}
                            >
                              <Typography
                                style={{
                                  fontFamily: fonts.fontFamily,
                                  fontSize: fonts.title,
                                  color: themes.blackDefault,
                                  fontWeight: 'bold',
                                }}
                              >
                                {trans('Not Added')}
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              style={{
                                textAlign: 'center',
                              }}
                            >
                              <Typography
                                style={{
                                  fontFamily: fonts.fontFamily,
                                  fontSize: fonts.subtitle,
                                  color: themes.defaultIcon,
                                }}
                              >
                                {trans(
                                  'Currently there is no Employee Directory',
                                )}
                              </Typography>
                            </Grid>
                          </Grid>
                        )}
                        
                        </div>
                      ) : (
                        <Loader width={100} height={100} />
                      )}
                    </Box>
                    <Box className="empPage">
                    {EmpDirectory && 
                    <Pagination 
                    count={count}
                    PageNumber={page}
                    RowsPerPage={rowPerPage}
                    setPage={getPageValue}
                    setRowsPerPage={getRowPerPageValue}
                    />
                    }
                    </Box>
                    <Grid
                      container
                      style={{
                        marginBottom: '1em',

                        alignItems: 'flex-end',
                        justifyContent: 'flex-end',
                        display: 'flex',
                        marginTop: '1em',
                      }}
                    >
                      <Grid item></Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
        </Grid>
    </Grid>
  );
};

export default EmpDirectoryPresenter;
